// styles.js
export const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

export const loaderStyle = {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '5px',
};
